/**
 * ChoirSelection component routing options.
 * This tells React Router which url path to use.
 * Treat this file as an enum.
 * @module choirSelectionRoutingOptions
 * @category ChoirSelection
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * Route to the MusicSelection component
 */
export const MUSIC_SELECTION = "MUSIC_SELECTION";

/**
 * Route to the ChoirMembers component
 */
export const CHOIR_MEMBERS = "CHOIR_MEMBERS";
